import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Topbar from "../Layout/Header/Topbar";
import Header from "../Layout/Header/Header-loggedIn";
import Footer from "../Layout/Footer/Footer";
import { countries } from "../Components/Registration/countries";
import { authenticate, make_request } from "../Utils/Utils";
const USER_SOURCES = [
  "Twitter",
  "Facebook",
  "Instagram",
  "Google",
  "News",
  "Office Colleague",
  "Friend",
  "Other",
];
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        name: "",
        email: "",
        country: "",
        password: "",
        password_confirmation: "",
        mobile: "",
        user_source: "",
        date_of_birth: "",
        organization: ""
      },
      nameError: "",
      organizationError: "",
      display_nameError: "",
      emailError: "",
      mobilenumError: "",
      dobError: "",
      passwordError: "",
      cpasswordError: "",
      api_errors: false,
      api_error_message: "",
      success_message: ""
    };
  }

  fetch_request = async () => {
    let responseJson = await make_request({
      path: "profile",
      method: "GET",
    });
    if (responseJson) {
      this.setState({
        user: responseJson.user,
      });
    }
  };

  async componentDidMount() {
    if (authenticate()) {
      this.fetch_request();
    } else {
      this.props.history.push("/login");
    }
  }

  validate = () => {
    let nameError = "";
    let emailError = "";
    let organizationError = "";
    let display_nameError = "";
    let mobilenumError = "";
    let dobError = "";
    let passwordError = "";
    let cpasswordError = "";

    /*NAME ERRORS*/
    if (!this.state.user.name) {
      nameError = "Name cannot be blank";
    } else {
      this.setState({ nameError: "" });
    }

    if (!this.state.user.name.match(/^[a-zA-Z ]*$/)) {
      nameError = "Enter correct name";
    } else {
      this.setState({ nameError: "" });
    }

    if (!this.state.user.display_name) {
      display_nameError = "Display name cannot be blank";
    } else {
      this.setState({ display_nameError: "" });
    }

    if (!this.state.user.organization) {
      organizationError = "Display name cannot be blank";
    } else {
      this.setState({ organizationError: "" });
    }

    // if (!this.state.user.display_name.match(/^[a-zA-Z 1-9]*$/)) {
    //   display_nameError = "Enter correct display name";
    // } else {
    //   this.setState({ display_nameError: "" });
    // }

    /*EMAIL ERRORS*/

    if (!this.state.user.email || !this.state.user.email.includes("@")) {
      emailError = "invalid email";
    } else {
      this.setState({ emailError: "" });
    }

    if (!this.state.user.email) {
      emailError = "Email cannot be blank";
    } else {
      this.setState({ emailError: "" });
    }

    /*MOBILE NUMBER ERROR*/

    if (!this.state.user.mobile || !this.state.user.mobile.match(/^[0-9]*$/)) {
      mobilenumError = "Enter correct number";
    } else {
      this.setState({ mobilenumError: "" });
    }

    if (!this.state.user.mobile) {
      mobilenumError = "Mobile number cannot be blank";
    } else {
      this.setState({ mobilenumError: "" });
    }

    /*DOB ERROR*/

    if (!this.state.user.date_of_birth) {
      dobError = "Date of birth cannot be blank";
    } else {
      this.setState({ dobError: "" });
    }

    /*PASSWORD ERROR*/

    if (!this.state.user.password) {
      passwordError = "Password cannot be blank";
    } else {
      this.setState({ passwordError: "" });
    }

    if (this.state.user.password !== this.state.user.password_confirmation) {
      cpasswordError = "Passwords do not match";
    } else {
      this.setState({ cpasswordError: "" });
    }

    if (!this.state.user.password_confirmation) {
      cpasswordError = "Enter password confirmation";
    } else {
      this.setState({ cpasswordError: "" });
    }

    /* PRINTING ERRORS */

    if (
      emailError ||
      nameError ||
      organizationError ||
      display_nameError ||
      mobilenumError ||
      passwordError ||
      cpasswordError ||
      dobError
    ) {
      this.setState({
        emailError,
        nameError,
        organizationError,
        display_nameError,
        mobilenumError,
        passwordError,
        cpasswordError,
        dobError,
      });
      return false;
    }

    return true;
  };

  handle_change = (event) => {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  };

  onFormSubmit = async (event) => {
    event.preventDefault();
    const isValid = this.validate();
    const { user } = this.state;

    if (!isValid) {
      return;
    }
    let responseJson = await make_request({
      path: "profile",
      method: "POST",
      body: user,
    });
    if (responseJson) {
      if (responseJson.status === "success") {
        this.setState({ api_errors: false });
        this.setState({ success_message: "Profile details has been updated successfully" });
      } else {
        console.log("responseJson => " + JSON.stringify(responseJson));

        let api_errors = responseJson.errors;
        let errorItems = api_errors.map((error) => (
          <li key="error">{error}</li>
        ));
        this.setState({ api_errors: true ,
          success_message: "",
          api_error_message: errorItems 
        });
      }
    }
  };

  render() {
    return (
      <div className="login Register innerBody">
        <Topbar />
        <Header />
        <div className="container">
          <div className="row update_form mt-5 mb-5">
            <h3 className="col-md-12 text-center mb-5"> MY PROFILE </h3>
            <div className="offset-xl-2 col-xl-8 offset-lg-1 col-lg-10 col-md-12 col-12 update_profile_box">
              <form onSubmit={this.onFormSubmit}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <input
                        type="text"
                        className="form-control"
                        defaultValue="Name"
                        id="name"
                        onChange={this.handle_change}
                        name="name"
                        value={this.state.user.name}
                        onChange={this.handle_change}
                      />
                      <div className="errmsg ml-2">{this.state.nameError}</div>
                    </div>

                    <div className="col-md-6 col-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Display Name *"
                        id="display_name"
                        name="display_name"
                        value={this.state.user.display_name}
                        onChange={this.handle_change}
                      />
                      <div className="errmsg ml-2">
                        {this.state.display_nameError}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email *"
                        id="email"
                        name="email"
                        readOnly={true}
                        value={this.state.user.email}
                        onChange={this.handle_change}
                      />
                      <div className="errmsg ml-2">{this.state.emailError}</div>
                    </div>

                    <div className="col-md-6 col-12">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Mobile *"
                        id="mobile"
                        name="mobile"
                        value={this.state.user.mobile}
                        onChange={this.handle_change}
                      />
                      <div className="errmsg ml-2">
                        {this.state.mobilenumError}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password *"
                        id="password"
                        name="password"
                        value={this.state.user.password}
                        onChange={this.handle_change}
                        autoComplete='off'
                      />
                      <div className="errmsg ml-2">{this.state.passwordError}</div>
                    </div>

                    <div className="col-md-6 col-12">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm Password *"
                        id="password_confirmation"
                        onChange={this.handle_change}
                        value={this.state.user.password_confirmation}
                        name="password_confirmation"
                        autoComplete='off'
                      />
                      <div className="errmsg ml-2">{this.state.cpasswordError}</div>
                    </div>
                  </div>

                  <div className="row country_drpdwn">
                    <div className="col-md-6 col-12">
                      <input
                        type="date"
                        className="form-control "
                        placeholder="Date of birth *"
                        id="date_of_birth"
                        value={this.state.user.date_of_birth}
                        onChange={this.handle_change}
                        name="date_of_birth"
                      />
                      <div className="errmsg ml-2">{this.state.dobError}</div>
                    </div>

                    <div className="col-md-5 col-12">
                      {countries(this.state, this.handle_change)}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 px-3 py-4 col-12">
                      <select
                        id="user_source"
                        name="user_source"
                        className="form-control"
                        value={this.state.user.user_source}
                        onChange={this.handle_change}
                      >
                        <option value="" disabled>
                          Where did you hear about us?
                        </option>
                        {USER_SOURCES.map((option) => (
                          <option value={option} key={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 col-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Company/Organization *"
                        id="organization"
                        name="organization"
                        value={this.state.user.organization}
                        onChange={this.handle_change}
                      />
                      <div className="errmsg ml-2">
                        {this.state.organizationError}
                      </div>
                    </div>
                  </div>

                  <div className="row d-flex">
                    <div className="col-12 text-center">
                      <button
                        id="register_btn"
                        type="button"
                        className="btn btn-yellow ml-2 mt-2"
                        onClick={this.onFormSubmit}
                      >
                        UPDATE DETAILS
                      </button>
                    </div>
                  </div>

                  <div className="wrong_txt mb-2 mt-4 text-center">
                    {this.state.api_errors && (
                      <div>
                        {" "}
                        <ul> {this.state.api_error_message}</ul>{" "}
                      </div>
                    )}
                  </div>

                  <div className="success_txt mb-2 mt-4 text-center">
                    {!this.state.api_errors && (
                      <span>
                        {this.state.success_message}
                      </span>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Profile;
